import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { ApiService } from '../../services/api.service';
import { Canale, Ondemand, OndemandHome } from '../../shared/interfacce.model';

@Component({
  selector: 'app-canale',
  templateUrl: './canale.component.html',
  styleUrls: ['./canale.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate(500, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class CanaleComponent implements OnInit {

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute) { }

  canale?: Canale;
  ondemands: Ondemand[] = [];
  ondemands_filtrati: OndemandHome[] = [];

  ondemandLimit: number = 10;

  loading: boolean = true;

  hasTriggered: boolean = false

  ngOnInit(): void {

    addEventListener('scroll', ($event) => {
      if (!this.hasTriggered && document.body.scrollHeight - (window.innerHeight + window.scrollY) >= 50 && this.ondemandLimit < this.ondemands.length) {
        this.hasTriggered = true; // blocca ulteriori esecuzioni
        setTimeout(() => {
          this.onMostra(10)
          this.hasTriggered = false;
        }, 1000);
      }
    })

    // Recupero l'id passato nell'url del canale
    let name = this.route.snapshot.paramMap.get('canale')!;

    // Recupero i dati del canale
    this.apiService.getCanaleByName(name).subscribe({
      next: (data) => this.canale = data,
      error: (err) => {
        this.loading = false;
        this.apiService.error("<p><strong>Il canale non è stato caricato correttamente! </strong></p> <p>Ricaricare la pagina oppure aspettare qualche secondo. </p><p>In caso di errore continuo contattaci a <strong><a href='mailto:webtv@7live.tv'>webtv@7live.tv</a></strong>!</p>")
      },
      complete: () => {
        
        // Recupero i video ondemand
        this.apiService.getOndemandsCategorie().subscribe({
          next: (data) => {
            this.ondemands_filtrati = [...data.map(ondemands => {
              ondemands.video = ondemands.video.filter(video => video.id_canale == this.canale!.id.toString())              
              return ondemands;
            })];            
          },
          error: (err) => {
            this.loading = false;
            this.apiService.error("<p><strong>I video Ondemand non sono stati caricati correttamente! </strong></p> <p>Ricaricare la pagina oppure aspettare qualche secondo. </p><p>In caso di errore continuo contattaci a <strong><a href='mailto:webtv@7live.tv'>webtv@7live.tv</a></strong>!</p>")
          },
          complete: () => this.loading = false
        })

      }
    })
  }

  onMostra(increment: number) {
    this.ondemandLimit += increment;
  }

  onOndemand(id: number) {
    this.router.navigate(['/ondemand/' + btoa("id_ondemand=" + id)]);
  }

}
